<template>
  <div v-if="orders && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="orders"
      dataFormaterKey="shop.print_order_template.template"
    />
  </div>
</template>
<script>
import Orders from "@/api/orders";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    orders: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("order").then(
      function (response) {
        if (response.data.status.isOK()) {
          // console.log(response);
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          Orders.ordersPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.orders = response.data.orders;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>